import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Users, Leaf, Sparkles, HeartPulse } from 'lucide-react';
const authorityItems = [{
  icon: Leaf,
  label: 'Protocolo Natural'
}, {
  icon: Sparkles,
  label: 'Sin Suplementos Caros'
}, {
  icon: HeartPulse,
  label: 'Resultados en 21 Días'
}];
export function Hero() {
  return <section className="relative pt-32 pb-16 md:pt-40 md:pb-24 overflow-hidden bg-cream" data-id="element-64">
      {/* Soft organic background blobs */}
      <div aria-hidden className="absolute -top-20 -right-24 w-[28rem] h-[28rem] rounded-full bg-salvia/20 blur-3xl pointer-events-none" data-id="element-65" />
      <div aria-hidden className="absolute -bottom-32 -left-20 w-[26rem] h-[26rem] rounded-full bg-olive blur-3xl pointer-events-none" data-id="element-66" />

      <div className="relative container mx-auto px-6 max-w-6xl" data-id="element-67">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-20" data-id="element-68">
          {/* Left Content */}
          <div className="w-full md:w-1/2 flex flex-col items-start" data-id="element-69">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-70">
              {/* Authority seal */}
              <div className="inline-flex items-center gap-2 py-1.5 pl-1.5 pr-4 rounded-full bg-white border border-salvia/50 mb-6 shadow-sm" data-id="element-71">
                <span className="w-6 h-6 rounded-full bg-forest text-white flex items-center justify-center text-[10px] font-black" data-id="element-72">
                  ✓
                </span>
                <span className="text-forest text-[11px] font-bold tracking-[0.22em] uppercase" data-id="element-73">
                  Protocolo Bio-Integral · 21 Días
                </span>
              </div>

              {/* Eyebrow */}
              <p className="text-xs md:text-sm font-bold tracking-[0.2em] uppercase text-salvia mb-4" data-id="element-74">
                Bienestar Digestivo Premium
              </p>

              <h1 className="font-serif text-4xl md:text-5xl lg:text-[3.75rem] font-semibold tracking-tight text-forest leading-[1.05] mb-6" data-id="element-75">
                Recupera tu{' '}
                <span className="italic font-normal text-forest/70" data-id="element-76">
                  vientre plano
                </span>{' '}
                y dile adiós a la hinchazón en 21 días
              </h1>
              <p className="font-sans text-lg md:text-xl text-forest/75 mb-8 max-w-lg leading-relaxed" data-id="element-77">
                El protocolo de biohacking digestivo de GUT LABS diseñado para
                mujeres que quieren resultados reales sin dietas restrictivas ni
                suplementos caros.
              </p>

              {/* Stack offer line */}
              <p className="font-sans text-sm md:text-[15px] text-forest font-semibold mb-10 max-w-lg leading-relaxed" data-id="element-78">
                Por solo <span className="text-forest font-bold" data-id="element-79">9,90€</span>{' '}
                accedes al pack completo: 3 Módulos + Lista de la Compra + Guía
                de Seguimiento Diario.
              </p>

              <div className="flex flex-col items-start gap-3 w-full sm:w-auto" data-id="element-80">
                <motion.a href="https://vyralea.com/cart/55754971611476:1" whileHover={{
                scale: 1.02,
                y: -2
              }} whileTap={{
                scale: 0.98
              }} className="w-full sm:w-auto bg-forest text-white px-10 py-6 rounded-full text-base md:text-lg font-bold tracking-tight text-center hover:bg-forest-dark transition-colors shadow-xl shadow-forest/25" data-id="element-81">
                  SÍ, QUIERO MI PROTOCOLO POR 9,90€
                </motion.a>
                <span className="text-xs text-forest/55 font-medium pl-1" data-id="element-82">
                  Acceso instantáneo · Pago 100% seguro
                </span>
              </div>

              <div className="mt-8 flex items-center gap-6 text-sm text-forest/70 font-medium" data-id="element-83">
                <div className="flex items-center gap-2" data-id="element-84">
                  <Users className="w-4 h-4 text-salvia" data-id="element-85" />
                  <span data-id="element-86">+1.200 mujeres</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-87">
                  <ShieldCheck className="w-4 h-4 text-salvia" data-id="element-88" />
                  <span data-id="element-89">Garantía 30 días</span>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Right Image */}
          <div className="w-full md:w-1/2" data-id="element-90">
            <motion.div initial={{
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="relative w-full aspect-square rounded-[2.5rem] shadow-2xl shadow-forest/10 overflow-hidden border border-white" data-id="element-91">
              <img src="https://cdn.magicpatterns.com/uploads/4g37VQ4Ur5GNzKroJ3soHh/MOCKUP_BUENO.png" alt="Protocolo GUT LABS™ — vientre plano y digestión ligera en 21 días" className="w-full h-full object-cover" data-id="element-92" />
            </motion.div>
          </div>
        </div>

        {/* Authority Row — 3 icons */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-16 md:mt-24 pt-10 md:pt-14 border-t border-salvia/40" data-id="element-93">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-4 max-w-4xl mx-auto" data-id="element-94">
            {authorityItems.map((item, i) => {
            const Icon = item.icon;
            return <div key={i} className="flex items-center justify-center gap-3 text-center" data-id="element-95">
                  <span className="w-11 h-11 rounded-full bg-salvia/20 flex items-center justify-center shrink-0" data-id="element-96">
                    <Icon className="w-5 h-5 text-forest" strokeWidth={2} data-id="element-97" />
                  </span>
                  <span className="text-sm md:text-[15px] font-bold tracking-tight text-forest uppercase" data-id="element-98">
                    {item.label}
                  </span>
                </div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}